import React, { useContext, useEffect, useState } from "react";
import { Form, Input, Button } from "antd";
import {
  CloseOutlined,
  UserOutlined,
  CheckOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import { TResponseModel } from "../../types/config";
import { useNavigate } from "react-router-dom";
import useFetch from "../../hooks/useFetch";
import { eFONTFAMILY, eResultCode } from "../../utils/enum";
import useToast from "../../hooks/useToast";
import { ToastOpen, ToastType } from "../../state/toast/slice";
import styles from "./auth.module.css";
import { UserContext } from "../../context";
import EncryptUtils from "../../utils/encrypt";
import {
  ForgotPasswordLink,
} from "../../utils/api.constant";

const ForgotPassword: React.FC = () => {
  const context: any = useContext(UserContext);
  const navigate = useNavigate();
  const { post } = useFetch();
  const { onShowToast } = useToast();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLinkSent, setIsLinkSent] = useState<boolean>(false);
  const [form] = Form.useForm();
  const emailId = context.user?.emailId;

  useEffect(() => {
    if (emailId) {
      form.setFieldsValue({ email: emailId });
    }
  }, [emailId, form]);

  const onSendLink = async (values: { email: string }) => {
    try {
      setIsLoading(true);
      const payload = {
        data: {
          email: values.email,
        },
      };
      const response: TResponseModel = await post(ForgotPasswordLink, payload);

      const { dataResponse, data } = response;
      const { returnCode, description } = dataResponse;

      if (returnCode === eResultCode.SUCCESS) {
        setIsLinkSent(true);
        onShowToast({
          type: ToastType.success,
          title: <CheckOutlined />,
          position: ToastOpen.centerTop,
          content: description,
        });
      } else {
        onShowToast({
          type: ToastType.error,
          title: <CloseOutlined />,
          position: ToastOpen.centerTop,
          content: description,
        });
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const backToLogin = () => {
    navigate("/login");
  };

  return (
    <div className={styles.parentWrapper}>
      {
        !isLinkSent ? (
          <Form
            form={form}
            name="forgotPassword"
            onFinish={onSendLink}
            size="middle"
            initialValues={{ email: emailId }}
          >
            <div className={styles.formHeader}>
              <span
                style={{ fontFamily: eFONTFAMILY.SEMIBOLD, fontSize: "22px" }}
              >
                Forgot Password?
              </span>
            </div>
            <p>Please enter your email to receive an reset link</p>
            <Form.Item
              name="email"
              rules={[
                { required: true, message: "Please input your Email!" },
                { type: "email", message: "Please enter a valid Email!" },
              ]}
            >
              <Input prefix={<UserOutlined />} placeholder="Email" />
            </Form.Item>
            <Form.Item>
              <Button
                block
                type="primary"
                htmlType="submit"
                loading={isLoading}
              >
                Send Reset Link
              </Button>
            </Form.Item>
          </Form>
        ) : (
          <Form name="verifyOTP" size="middle">
            <div className={styles.formHeader}>
              <h1>Verify Reset Link</h1>
            </div>
            <p>Please check the reset link sent to your email address</p>
          </Form>
        )
      }
      <Button type="link" onClick={backToLogin}>
        <ArrowLeftOutlined />
        Back
      </Button>
    </div>
  );
};

export default ForgotPassword;
